(() => {
  const cardSelector = '[data-yx-product-card]';
  const swatchSelector = '[data-yx-product-swatch]';

  function selectVariant(card, swatch) {
    card.querySelectorAll(swatchSelector).forEach((button) => {
      const isActive = button === swatch;
      button.classList.toggle('yx-product-card__swatch--active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    const variantId = swatch.getAttribute('data-yx-variant-id');
    const variantInput = card.querySelector('[data-yx-variant-input]');
    if (variantInput && variantId) {
      variantInput.value = variantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const variantPrice = swatch.getAttribute('data-yx-variant-price');
    const priceNode = card.querySelector('[data-yx-card-price]');
    if (priceNode && variantPrice) priceNode.textContent = variantPrice;

    const variantCompare = swatch.getAttribute('data-yx-variant-compare');
    const compareNode = card.querySelector('[data-yx-card-compare]');
    if (compareNode) {
      if (variantCompare) {
        compareNode.textContent = variantCompare;
        compareNode.hidden = false;
      } else {
        compareNode.hidden = true;
      }
    }

    const variantDiscount = Number(swatch.getAttribute('data-yx-variant-discount') || 0);
    const discountNode = card.querySelector('[data-yx-card-discount]');
    if (discountNode) {
      const discountPrefix = discountNode.dataset.yxDiscountPrefix || 'Save';
      const discountLabel = variantDiscount > 0 ? `${discountPrefix} ${variantDiscount}%` : '';
      discountNode.textContent = discountLabel;
      discountNode.dataset.label = discountLabel;
      discountNode.hidden = variantDiscount <= 0;
    }

    const variantImage = swatch.getAttribute('data-yx-variant-image');
    const productImage = swatch.getAttribute('data-yx-variant-product-image');
    const imageNode = card.querySelector('.yx-product-card__media-main');
    if (imageNode) {
      if (!imageNode._yxDefaultMedia) {
        imageNode._yxDefaultMedia = {
          src: imageNode.getAttribute('src') || '',
          srcset: imageNode.getAttribute('srcset'),
          sizes: imageNode.getAttribute('sizes')
        };
      }
      if (productImage || variantImage) {
        imageNode.setAttribute('src', productImage || variantImage);
        imageNode.removeAttribute('srcset');
        imageNode.removeAttribute('sizes');
      } else {
        imageNode.setAttribute('src', imageNode._yxDefaultMedia.src);
        if (imageNode._yxDefaultMedia.srcset) imageNode.setAttribute('srcset', imageNode._yxDefaultMedia.srcset);
        else imageNode.removeAttribute('srcset');
        if (imageNode._yxDefaultMedia.sizes) imageNode.setAttribute('sizes', imageNode._yxDefaultMedia.sizes);
        else imageNode.removeAttribute('sizes');
      }
    }

    const hoverNode = card.querySelector('.yx-product-card__media-hover');
    if (hoverNode && productImage && variantImage) {
      hoverNode.setAttribute('src', variantImage);
      hoverNode.removeAttribute('srcset');
      hoverNode.removeAttribute('sizes');
    }

    const variantUrl = swatch.getAttribute('data-yx-variant-url');
    if (variantUrl) {
      card.querySelectorAll('.yx-product-card__media-link, .yx-product-card__title a').forEach((link) => {
        link.setAttribute('href', variantUrl);
      });
    }
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const swatch = event.target.closest(swatchSelector);
    if (!swatch) return;
    const card = swatch.closest(cardSelector);
    if (!card) return;

    event.preventDefault();
    selectVariant(card, swatch);
  });

})();
